(() => {
  const selector = '[data-fdp-shop-pay-url]';
  const sectionId = 'fdp-card-payment-terms';
  const cache = new Map();
  const loading = new WeakSet();

  function buildUrl(raw) {
    if (!raw) return null;
    try {
      const url = new URL(raw, window.location.origin);

      // Keep locale prefix such as /fr or /en, but remove collection context.
      const match = url.pathname.match(/^(.*?\/products\/[^/?#]+)/);
      if (!match) return null;

      url.pathname = match[1];
      url.search = '';
      url.hash = '';
      url.searchParams.set('section_id', sectionId);
      return url.toString();
    } catch (error) {
      return null;
    }
  }

  async function requestTerms(url) {
    if (cache.has(url)) return cache.get(url);

    const promise = fetch(url, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    })
      .then(response => response.ok ? response.text() : '')
      .then(html => {
        if (!html) return '';
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        const result = template.content.querySelector('.fdp-official-payment-terms');
        return result ? result.outerHTML : '';
      })
      .catch(() => '');

    cache.set(url, promise);
    return promise;
  }

  async function hydrate(element) {
    if (!element || loading.has(element) || element.dataset.fdpShopPayLoaded === 'true') return;

    const url = buildUrl(element.dataset.fdpShopPayUrl);
    if (!url) {
      element.remove();
      return;
    }

    loading.add(element);
    const html = await requestTerms(url);

    if (element.isConnected) {
      if (html) {
        element.innerHTML = html;
        element.dataset.fdpShopPayLoaded = 'true';
      } else {
        // Shopify returned no terms: product or market is not eligible.
        element.remove();
      }
    }

    loading.delete(element);
  }

  function scan(root = document) {
    if (root.matches?.(selector)) hydrate(root);
    root.querySelectorAll?.(selector).forEach(hydrate);
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node instanceof Element) scan(node);
      });
    });
  });

  function init() {
    scan(document);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    // USF can replace the grid without always producing a useful mutation
    // sequence. These events and delayed scans cover filtering and pagination.
    document.addEventListener('click', event => {
      if (event.target.closest('.usf-filters, .usf-facet, .usf-sr-pages, .usf-c-select')) {
        setTimeout(() => scan(document), 400);
        setTimeout(() => scan(document), 1200);
      }
    });

    window.addEventListener('popstate', () => setTimeout(() => scan(document), 500));
    setTimeout(() => scan(document), 800);
    setTimeout(() => scan(document), 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();